import DeliveryOption from '@/controllers/options/DeliveryOption';
import DeliveryOptionConstants from '@/controllers/options/DeliveryOptionConstants';
import DeliveryOptionsProvider from '@/models/DeliveryOptionsProvider';
import IOptionHandler from './IOptionHandler';

class TimerOptionHandler implements IOptionHandler {
  execute(provider: DeliveryOptionsProvider, map: Map<string, unknown>): void {
    if (map.get(DeliveryOptionConstants.TIMER_OPTION)) {
      const timerMap: Map<string, unknown> | undefined = new Map(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Object.entries(map.get(DeliveryOptionConstants.TIMER_OPTION) as any)
      );
      if (timerMap.get('use_timer')) {
        const deliveryOption: DeliveryOption = new DeliveryOption(DeliveryOptionConstants.TIMER_OPTION);

        this.addOption(deliveryOption, timerMap, 'time_limit', '0');
        deliveryOption.addSetting('elapsedTime', '0');

        this.addOption(deliveryOption, timerMap, 'warning_time', '0');

        const timerType = (timerMap.get('time_limit_type') as string) || 'Soft';
        this.addOption(deliveryOption, timerMap, 'time_limit_type', timerType);

        provider.addDeliveryOption(deliveryOption);
      }
    }
  }

  private addOption(
    deliveryOption: DeliveryOption,
    map: Map<string, unknown>,
    key: string,
    defaultValue: string
  ): void {
    let valueToSave: string = defaultValue;
    const value: unknown = map.get(key);
    if (value) {
      valueToSave = '' + value;
    }
    deliveryOption.addSetting(key, valueToSave);
  }
}

export default TimerOptionHandler;
